import { Appl } from '../../../core/Appl';
import { NavItem } from '../../../core/services/Models';
import { SpcService } from './SpcService';
import EstimateDetailsViewModel from './spcSubmission/Estimate/EstimateDetailsViewModel';
import SpcSubmissionListViewModel from './spcSubmission/list/SpcSubmissionListViewModel';
import SpcViewModel from './spcTest/SpcViewModel';

export default class SpcModule {

  public static MenuItems(): Array<NavItem> {

    let menuItems: Array<NavItem> = [];
    return menuItems
  }

  public static init(): void {
    Appl.Services.add('ISpcService', SpcService);
    Appl.Services.add('SpcViewModel', SpcViewModel);
    Appl.Services.add('SpcSubmissionListViewModel', SpcSubmissionListViewModel);
    Appl.Services.add('EstimateDetailsViewModel', EstimateDetailsViewModel);
  }
}
